module.exports = __webpack_public_path__ + "static/media/CNBC_Logo_Black.b273368b.svg";